'use client';

import * as React from 'react';

import { Activity, BookOpenText, CreditCard, Sparkles } from 'lucide-react';

import { HomeAnchorLink } from '@/components/home-anchor-link';
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle,
} from '@/components/ui/navigation-menu';

export const menuItems = [
  {
    label: 'Features',
    href: '/#features',
    icon: Sparkles,
  },
  {
    label: 'Pricing',
    href: '/#pricing',
    icon: CreditCard,
  },
  {
    label: 'FAQs',
    href: '/#faq',
    icon: BookOpenText,
  },
  // {
  //   label: 'Docs',
  //   href: '/docs',
  //   icon: BookOpenText,
  // },
  {
    label: 'Status',
    href: '/status-page',
    icon: Activity,
  },
];

export function PublicNavigationMenu() {
  return (
    <NavigationMenu viewport={false}>
      <NavigationMenuList>
        {menuItems.map((item) => (
          <NavigationMenuItem key={item.label}>
            <NavigationMenuLink asChild>
              <HomeAnchorLink
                href={item.href}
                scroll={false}
                className="flex flex-row items-center gap-2"
              >
                <item.icon />
                <span>{item.label}</span>
              </HomeAnchorLink>
            </NavigationMenuLink>
          </NavigationMenuItem>
        ))}
      </NavigationMenuList>
    </NavigationMenu>
  );
}

function ListItem({
  title,
  children,
  href,
  ...props
}: React.ComponentPropsWithoutRef<'li'> & { href: string }) {
  return (
    <li {...props}>
      <NavigationMenuLink asChild>
        <HomeAnchorLink href={href}>
          <div className="text-sm leading-none font-medium">{title}</div>
          <p className="text-muted-foreground line-clamp-2 text-sm leading-snug">{children}</p>
        </HomeAnchorLink>
      </NavigationMenuLink>
    </li>
  );
}
